import { PaginatedResponse } from './paginated-response';

export class User {
  'Approved Dollar Figure': number;
  'Email Address': string;
  'First Name': string;
  'Last Name': string;
  'Organization ID': string;
  'SMS Phone Number': string;
  'User ID': string;
  'Team ID': string;
  'Team Notes': string;
  Company: string;
  Position: string;
  isAdmin: boolean;
  name: string;
  markets: string[];

  constructor(data: any = {}) {
    this['User ID'] = data['User ID'] || '';
    this['First Name'] = data['First Name'] || '';
    this['Last Name'] = data['Last Name'] || '';
    this['Email Address'] = data['Email Address'] || '';
    this['SMS Phone Number'] = data['SMS Phone Number'] || '';
    this['Organization ID'] = data['Organization ID'] || '';
    this.Company = data.Company || '';
    this.Position = data.Position || '';
    this.isAdmin = data.isAdmin || false;
    this.markets = data.markets || [];
  }
}

export class PaginatedUserDTO extends PaginatedResponse {
  records: User[];
}

export class UserInfo {
  displayName: string;
  firstName: string;
  lastName: string;
  userId: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/user-model.ts